var map = {
	"./barszcz.jpg": 7014,
	"./barszcz_s.jpg": 8507,
	"./catering_box.jpg": 5946,
	"./catering_box_s.jpg": 4730,
	"./cukinia.jpg": 4813,
	"./cukinia_s.jpg": 263,
	"./de_volaille.jpg": 7797,
	"./de_volaille_s.jpg": 8248,
	"./grzanka.jpg": 8354,
	"./grzanka_s.jpg": 316,
	"./gulaszowa.jpg": 8847,
	"./gulaszowa_s.jpg": 1902,
	"./klopsy_dorsz.jpg": 2617,
	"./klopsy_dorsz_s.jpg": 4314,
	"./konfitura_cebula.jpg": 6493,
	"./konfitura_cebula_s.jpg": 9150,
	"./losos.jpg": 7044,
	"./losos_s.jpg": 8318,
	"./miseczki_boczek.jpg": 8530,
	"./miseczki_boczek_s.jpg": 4486,
	"./miseczki_pom.jpg": 6436,
	"./miseczki_pom_s.jpg": 4694,
	"./mus_groszek.jpg": 6681,
	"./mus_groszek_s.jpg": 5891,
	"./no_img.jpg": 7915,
	"./no_img_s.jpg": 4069,
	"./papryka_marynowana.jpg": 9587,
	"./papryka_marynowana_s.jpg": 5757,
	"./pasztet_ges.jpg": 2404,
	"./pasztet_ges_s.jpg": 5613,
	"./poledwiczka_kurczak.jpg": 9771,
	"./poledwiczka_kurczak_s.jpg": 5777,
	"./poledwiczka_wedzona.jpg": 783,
	"./poledwiczka_wedzona_s.jpg": 8395,
	"./rolada_szpinak.jpg": 4370,
	"./rolada_szpinak_s.jpg": 7179,
	"./rolada_zurawina.jpg": 3295,
	"./rolada_zurawina_s.jpg": 5715,
	"./salatka_burak.jpg": 7203,
	"./salatka_burak_s.jpg": 9479,
	"./salatka_warzywa.jpg": 4374,
	"./salatka_warzywa_s.jpg": 2320,
	"./sledz_po_kaszubsku.jpg": 4643,
	"./sledz_po_kaszubsku_s.jpg": 9338,
	"./sledz_w_oleju.jpg": 7814,
	"./sledz_w_oleju_s.jpg": 7176,
	"./sledz_w_smiet.jpg": 4154,
	"./sledz_w_smiet_s.jpg": 9401,
	"./smalec.jpg": 141,
	"./smalec_chrzan.jpg": 8168,
	"./smalec_chrzan_s.jpg": 740,
	"./smalec_s.jpg": 3148,
	"./szprotka.jpg": 6350,
	"./szprotka_s.jpg": 3855,
	"./tatar_susz_pom.jpg": 3838,
	"./tatar_susz_pom_s.jpg": 5329,
	"./wolowina_szmur.jpg": 5879,
	"./wolowina_szmur_s.jpg": 2442,
	"./zurek.jpg": 1338,
	"./zurek_s.jpg": 5347,
	"./zylc.jpg": 4771,
	"./zylc_kaszub.jpg": 2928,
	"./zylc_kaszub_s.jpg": 5920,
	"./zylc_s.jpg": 3462
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5227;